module.exports = __webpack_public_path__ + "images/rich_heading/small_appliance/pc/icon_8338bf1f53a066197f98a33e2323c692.png";